import { render, staticRenderFns } from "./Barefoot.vue?vue&type=template&id=0aa74e7c&scoped=true&"
import script from "./Barefoot.vue?vue&type=script&lang=js&"
export * from "./Barefoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa74e7c",
  null
  
)

export default component.exports